import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Verifica se é base64 válido
function isValidBase64Image(base64) {
  if (!base64 || typeof base64 !== 'string') return false;
  if (base64.startsWith('data:image')) return true;
  const base64clean = base64.replace(/\s/g, '');
  const base64regex = /^[A-Za-z0-9+/=]+$/;
  return base64regex.test(base64clean);
}

// Converte para dataURL padrão
function normalizeBase64Image(base64, tipo = 'jpeg') {
  if (!base64 || !isValidBase64Image(base64)) return null;
  if (base64.startsWith('data:image')) return base64;
  const base64clean = base64.replace(/\s/g, '');
  return `data:image/${tipo};base64,${base64clean}`;
}

// Recorta imagem em círculo usando canvas HTML
async function cortarImagemEmCirculo(src, tamanho = 60) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = src;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = tamanho;
      canvas.height = tamanho;
      const ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.arc(tamanho / 2, tamanho / 2, tamanho / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();
      ctx.drawImage(img, 0, 0, tamanho, tamanho);
      resolve(canvas.toDataURL());
    };
    img.onerror = () => resolve(src); // fallback direto
  });
}

// Função principal
async function RefeicaoPDF(funcionarios) {
  const funcionariosEtiqueta = funcionarios.filter((f) => f.marmitex === 1);

  const criarEtiqueta = async (cliente) => {
    const imagemDefault = 'https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg';
    const base64Normalizado = normalizeBase64Image(cliente.foto);
    const imagemParaUsar = base64Normalizado || imagemDefault;
    const imagemCircular = await cortarImagemEmCirculo(imagemParaUsar);

    const imagemFuncionario = {
      image: imagemCircular,
      width: 60,
      height: 60,
      margin: [0, 0, 10, 0],
    };

    return {
      table: {
        widths: ['auto', '*'],
        body: [
          [
            imagemFuncionario,
            {
              stack: [
                { text: cliente.nome, fontSize: 15, bold: true, margin: [0, 0, 0, 6] },
                {
                  columns: [
                    { text: 'Chapa:', bold: true, fontSize: 10, width: 50 },
                    { text: cliente.chapa, fontSize: 10, noWrap: true },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  columns: [
                    { text: 'Loja:', bold: true, fontSize: 10, width: 50 },
                    { text: cliente.loja, fontSize: 10, noWrap: true },
                  ],
                  margin: [0, 0, 0, 6],
                },
                {
                  text: 'Cardápio: ' + cliente.menu,
                  bold: true,
                  fontSize: 10,
                  margin: [0, 0, 0, 2],
                },
                {
                  text: 'Obs: ' + (cliente.observacao || ''),
                  fontSize: 10,
                  italics: true,
                  margin: [0, 0, 0, 6],
                },
                {
                  columns: [
                    { text: 'Turno:', bold: true, fontSize: 10, width: 50 },
                    {
                      text: cliente.turno === 2 ? 'Segundo Turno' : 'Primeiro turno',
                      bold: true,
                      fontSize: 10,
                      noWrap: true,
                    },
                  ],
                },
              ],
            },
          ],
        ],
      },
      layout: {
        hLineWidth: () => 1,
        vLineWidth: () => 1,
        hLineColor: () => '#000000',
        vLineColor: () => '#000000',
        paddingTop: () => 5,
        paddingBottom: () => 5,
        paddingLeft: () => 5,
        paddingRight: () => 5,
        hLineStyle: () => ({ dash: { length: 3, space: 3 } }),
        vLineStyle: () => ({ dash: { length: 3, space: 3 } }),
      },
      keepTogether: true,
    };
  };

  const etiquetasEmPaginas = [];
  const etiquetasPorLinha = 2;
  const etiquetasPorPagina = 8;

  for (let i = 0; i < funcionariosEtiqueta.length; i += etiquetasPorPagina) {
    const pagina = [];
    const bloco = funcionariosEtiqueta.slice(i, i + etiquetasPorPagina);

    for (let j = 0; j < bloco.length; j += etiquetasPorLinha) {
      const etq1 = await criarEtiqueta(bloco[j]);
      const etq2 = bloco[j + 1] ? await criarEtiqueta(bloco[j + 1]) : null;

      const linha = {
        columns: [],
        columnGap: 10,
        margin: [0, 0, 0, 10],
      };

      if (etq1) linha.columns.push(etq1);
      if (etq2) linha.columns.push(etq2);
      if (!etq2) linha.columns.push({ text: '', width: '*' });

      pagina.push(linha);
    }

    etiquetasEmPaginas.push(...pagina, { text: '', pageBreak: 'after' });
  }

  if (etiquetasEmPaginas.length > 0) {
    const ultima = etiquetasEmPaginas[etiquetasEmPaginas.length - 1];
    if (ultima.pageBreak) delete ultima.pageBreak;
  }

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [15, 15, 15, 15],
    content: etiquetasEmPaginas,
    footer: function (currentPage, pageCount) {
      return {
        text: `${currentPage} / ${pageCount}`,
        alignment: 'right',
        fontSize: 9,
        margin: [20, 10, 10, 20],
      };
    },
  };

  try {
    pdfMake.createPdf(docDefinition).download('marmitex.pdf');
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
  }
}

export default RefeicaoPDF;
